import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { AccountsService } from '../../services/accounts.service';
import { Account } from '../../models/account.model';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '../../models/language.model';

@Component({
  selector: 'configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit {
  username: string;
  accounts: Account[] = [];
  languages: Language[] = [];
  selectedAccount: Account;
  selectedLanguage: Language;
  selectedAccountId: string;
  loading: boolean;
  colors = [
    'rgb(255, 215, 101)',
    'rgb(255, 158, 143)',
    'rgb(135, 216, 114)',
    'rgb(114, 216, 207)',
    'rgb(143, 169, 228)',
    'rgb(216, 161, 234)',
    'rgb(234, 161, 201)'
  ];

  headerStyle = {
    background: this.getRandomColor()
  }

  constructor(private authService: AuthService, private accountsService: AccountsService, private translateService: TranslateService) {
    this.username = authService.getAuthData().username;
  }

  ngOnInit() {
    this.authService.selectedAccount$.subscribe(d => this.selectedAccountId = d);

    this.fillLanguages();
    this.getAccountsInfo();
  }

  logout() {
    this.authService.logout();
  }

  handleAccountSelectionChange(event: MatSelectChange) {
    this.selectedAccount = this.accounts.filter(a => a.AccountID === event.value.AccountID)[0];
    const accountId = this.selectedAccount.AccountID.toString();
    localStorage.setItem("acc", accountId);
    this.authService.setSelectedAccountId(accountId);
  }

  handleLanguageSelectionChange(event) {
    this.translateService.use(event.value.key);
    localStorage.setItem("lang", event.value.key);
    this.setSelectedLanguage();
  }

  private getAccountsInfo() {
    if (this.authService.userAccounts && this.authService.userAccounts.length > 0) {
      this.loading = true;
      let defaultAccount = this.authService.getAuthData().accountID;
      if (!this.authService.userAccounts.includes(this.selectedAccountId))
        this.selectedAccountId = defaultAccount;
      this.authService.userAccounts.map(a => {
        this.accountsService.getAccount(a).subscribe(
          res => {
            this.accounts.push(res);
            if (a === this.selectedAccountId)
              this.selectedAccount = res;
          },
          e => {
            console.log(e);
          },
          () => {
            this.loading = false;
          }
        );
      });
    }
  }

  private fillLanguages() {
    this.languages = [
      {
        key: 'pt',
        name: this.translateService.get('languages.pt')
      },
      {
        key: 'en',
        name: this.translateService.get('languages.en')
      }
      ,
      {
        key: 'es',
        name: this.translateService.get('languages.es')
      }
    ]

    this.setSelectedLanguage();
  }

  private setSelectedLanguage() {
    const storedLanguage = localStorage.getItem("lang");
    this.selectedLanguage = this.languages.filter(l => l.key === storedLanguage)[0];
    this.selectedLanguage.name = this.translateService.get(`languages.${storedLanguage}`);
  }

  private getRandomColor() {
    return this.colors[Math.floor(Math.random() * this.colors.length)]
  }
}